import { useCallback, useEffect, useState } from 'react';
// eslint-disable-next-line prettier/prettier
import {
  AttachmentResponse as AddresseeAttachmentResponse
} from '@sdir/httpclient/lib/clients/core/commonaddressee';
import { Loadable } from '../../types';
import { useCurrentAddressee } from './useCurrentAddressee';

export const useAddresseeAttachment = (
  addresseeAttachment: AddresseeAttachmentResponse | null
): Loadable<File> => {
  const { getAddresseeAttachment } = useCurrentAddressee();

  const [downloadedFile, setDownloadedFile] = useState<File>();
  const [fileError, setFileError] = useState<Error | null>(null);

  const loadFile = useCallback(
    (attachment: AddresseeAttachmentResponse) => {
      setDownloadedFile(undefined);
      setFileError(null);
      getAddresseeAttachment?.(attachment).then(setDownloadedFile).catch(setFileError);
    },
    [getAddresseeAttachment]
  );

  useEffect(() => {
    if (addresseeAttachment) {
      loadFile(addresseeAttachment);
    }
  }, [addresseeAttachment, loadFile]);

  if (!addresseeAttachment) return {};

  if (downloadedFile) return { result: downloadedFile };
  if (fileError) return { error: fileError };
  return { loading: true };
};
